var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C7.286 22 4.929 22 3.464 20.536 2 19.071 2 16.714 2 12 2 7.286 2 4.929 3.464 3.464 4.929 2 7.286 2 12 2c4.714 0 7.071 0 8.536 1.464C22 4.929 22 7.286 22 12c0 4.714 0 7.071-1.464 8.536C19.071 22 16.714 22 12 22ZM16.03 8.97c.293.293.293.768 0 1.06l-5 5c-.293.293-.768.293-1.06 0l-2-2c-.293-.293-.293-.768 0-1.06s.768-.293 1.06 0L10.5 13.44l4.47-4.47c.293-.293.768-.293 1.06 0Z",
    fill: "#15a832"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.3e51c71b58ff21f5833de79d76639048.svg";
export { ForwardRef as ReactComponent };